import type { ResolvedComponent } from '@inertiajs/react';
import { Button } from '@/components/ui/Button';
import { PageHeader } from '@/components/ui/PageHeader';
import { Quote } from '@/components/ui/Quote';
import { RevealOnScroll } from '@/components/ui/RevealOnScroll';
import { ReviewPhotos } from '@/components/testimonials/ReviewPhotos';
import { TestimonialsCatalog } from '@/data/testimonials';
import { trackUmamiEvent } from '@/lib/analytics';

const wrap = 'mx-auto max-w-[1120px] px-5 md:px-10';
const sectionClassName = 'border-line border-t py-[52px] md:py-20';

const Testimonials: ResolvedComponent = () => (
  <>
    <div className={wrap}>
      <PageHeader
        eyebrow="Kind words"
        spark
        title={
          <>
            Trusted in homes <em>like yours</em>.
          </>
        }
        lead="A few notes from the people we clean for."
      />
    </div>

    {/* Testimonials list */}
    <RevealOnScroll>
      <section className="pt-1 pb-[52px] md:pb-20">
        <div className={wrap}>
          {TestimonialsCatalog.map((testimonial) => (
            <div key={testimonial.name} className="border-line border-t py-[34px] first:border-t-0">
              <Quote size="md" by={testimonial.name} role={testimonial.role}>
                “{testimonial.description}”
              </Quote>
              {testimonial.layout === 'gallery' ? (
                <ReviewPhotos layout="gallery" photos={testimonial.photos} />
              ) : (
                <ReviewPhotos layout="beforeAfter" beforeAfter={testimonial.beforeAfter} />
              )}
            </div>
          ))}
        </div>
      </section>
    </RevealOnScroll>

    {/* Closing CTA */}
    <RevealOnScroll>
      <section className={sectionClassName}>
        <div className={wrap}>
          <h2 className="t-h2 [&_em]:text-primary-deep mb-6 [&_em]:italic">
            Join them — <em>book your first visit</em>.
          </h2>
          <Button
            variant="solid"
            as="link"
            href="/contact"
            onClick={() => trackUmamiEvent('cta_request_visit', { location: 'testimonials' })}
          >
            Request a visit
          </Button>
        </div>
      </section>
    </RevealOnScroll>
  </>
);

export default Testimonials;
